import { Link } from "@tanstack/react-router";
import { Phone, MessageCircle, ArrowRight } from "lucide-react";
import { SITE } from "@/config/site";

export function CTAButtons({ variant = "row" }: { variant?: "row" | "stack" }) {
  return (
    <div className={variant === "stack" ? "flex flex-col gap-3" : "flex flex-wrap gap-3"}>
      <Link to="/quote" className="btn-primary">
        Get a free quote <ArrowRight className="h-4 w-4" />
      </Link>
      <a href={SITE.whatsapp} target="_blank" rel="noreferrer" className="btn-whatsapp">
        <MessageCircle className="h-4 w-4" /> WhatsApp Us
      </a>
      <a href={`tel:${SITE.phone}`} className="btn-outline">
        <Phone className="h-4 w-4" /> Call {SITE.phoneDisplay}
      </a>
    </div>
  );
}
